export const PLANS = {
  ENTERPRISE: "enterprise",
  PRO: "pro",
  STANDARD: "standard",
};
